module.exports = __webpack_public_path__ + "static/media/blue-jays-2024-mb-fr.c3e11a57.mp4";